// DS: MO3.8
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatDollars } from '../utils/formatting';
import s from './DiscountLabel.scss';
const DiscountLabel = ({ discount, className, textVariant = 'percent', size = 'medium', opaque = false, reversedTheme = false })=>{
    const { t } = useTranslation();
    if (!discount || !discount.amount || !discount.amount.percent) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], s[size], opaque && s['opaque'], reversedTheme && s['reversed-theme'], className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['discount']
    }, textVariant === 'subscription' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, discount.amount.percent === 100 ? t('common.sale.firstMonthFree') : `${t('common.sale.firstMonthOnly')} ${discount.amount.percent}% ${t('common.off')}`), textVariant === 'percent' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, discount.amount.percent, "% ", t('common.off')), textVariant === 'dollars' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, formatDollars(discount.amount.usd), " ", t('common.off')), textVariant === 'sale' && /*#__PURE__*/ React.createElement("span", {
        className: s['percent']
    }, t('common.onSale'))));
};
DiscountLabel.displayName = 'DiscountLabel';
export default DiscountLabel;

//# sourceMappingURL=DiscountLabel.js.map